import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utility/axiosInstance";

export interface QdrantInstance {
    id: number;
    name: string;
    version: string;
    status: "provisioning" | "ready" | "error";
    floating_ip: string | null;
    private_ip?: string | null;
    port: number;
    instance_id: string;
    created_at: string;
    api_key?: string;
}

interface QdrantState {
    instances: QdrantInstance[];
    status: "idle" | "loading" | "succeeded" | "failed";
    error: string | null;
}

const initialState: QdrantState = { instances: [], status: "idle", error: null };

export const fetchQdrant = createAsyncThunk("qdrant/fetch", async () => {
    const res = await axiosInstance.get("/v1/qdrant");
    return res.data as QdrantInstance[];
});

export const deleteQdrant = createAsyncThunk("qdrant/delete", async (id: number) => {
    await axiosInstance.delete(`/v1/qdrant/${id}`);
    return id;
});

const qdrantSlice = createSlice({
    name: "qdrant",
    initialState,
    reducers: {
        addQdrant: (state, action) => { state.instances.unshift(action.payload); },
        updateQdrantStatus: (state, action) => {
            const inst = state.instances.find(i => i.id === action.payload.id);
            if (inst) {
                inst.status = action.payload.status;
                inst.floating_ip = action.payload.floating_ip ?? inst.floating_ip;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchQdrant.pending,    (s) => { s.status = "loading"; })
            .addCase(fetchQdrant.fulfilled,  (s, a) => { s.status = "succeeded"; s.instances = a.payload; })
            .addCase(fetchQdrant.rejected,   (s, a) => { s.status = "failed"; s.error = a.error.message ?? null; })
            .addCase(deleteQdrant.fulfilled, (s, a) => { s.instances = s.instances.filter(i => i.id !== a.payload); });
    },
});

export const { addQdrant, updateQdrantStatus } = qdrantSlice.actions;
export default qdrantSlice.reducer;
